import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

// Create an API thunk for fetching data
export const deleteContracts = createApi('api/cd/contracts/delete-contracts', 'PUT');

const DeleteContract = createSlice({
  name: 'DeleteContract',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteContracts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteContracts.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteContracts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DeleteContract.reducer;